/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_DoneInputs */

const en_us2_plan_edit_done = /** @type {(inputs: Plan_Edit_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done editing`)
};

const pt_br2_plan_edit_done = /** @type {(inputs: Plan_Edit_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir edição`)
};

const es_419_plan_edit_done = /** @type {(inputs: Plan_Edit_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar edición`)
};

const pt_pt2_plan_edit_done = /** @type {(inputs: Plan_Edit_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir edição`)
};

const fr_fr2_plan_edit_done = /** @type {(inputs: Plan_Edit_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer`)
};

const de_de2_plan_edit_done = /** @type {(inputs: Plan_Edit_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig`)
};

const it_it2_plan_edit_done = /** @type {(inputs: Plan_Edit_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine modifiche`)
};

/**
* | output |
* | --- |
* | "Done editing" |
*
* @param {Plan_Edit_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_done = /** @type {((inputs?: Plan_Edit_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_done(inputs)
	if (locale === "es-419") return es_419_plan_edit_done(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_done(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_done(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_done(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_done(inputs)
	return en_us2_plan_edit_done(inputs)
});
export { plan_edit_done as "plan-edit.done" }